module.exports = __webpack_public_path__ + "static/media/YF52_6.945088bd.jpg";